import React, { useEffect } from 'react';
import { useDropzone } from "react-dropzone";

import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import ErrorIcon from '@mui/icons-material/Error';

export function AdjustDimension(height, width) {
  const maxDimension = 300;
  let adjustedHeight = height;
  let adjustedWidth = width;

  if (adjustedHeight > maxDimension || adjustedWidth > maxDimension) {
    if (adjustedHeight > maxDimension) {
      adjustedHeight = maxDimension;
      adjustedWidth = width / height * adjustedHeight;
    }
    if (adjustedWidth > maxDimension) {
      adjustedWidth = maxDimension;
      adjustedHeight = height/width * adjustedWidth;
    }

    adjustedHeight = Math.round(adjustedHeight);
    adjustedWidth = Math.round(adjustedWidth);
  }

  return { height: adjustedHeight, width: adjustedWidth }
}

function PhotoUploadPanel(props) {
  const [dimension, setDimension] = React.useState({height: 0, width: 0})
  const [error, setError] = React.useState(null)
  const errMsg = "Failed to upload. Please try again.";

  useEffect(() => {
    if (!!props.photo) {
      const img = new Image();
      img.onload = () => {
        const adjusted = AdjustDimension(img.height, img.width);
        setDimension({height: adjusted.height, width: adjusted.width});
      };
      img.src = props.photo;
    }
  }, [props.photo]);

  const onDrop = React.useCallback((files) => {
    props.onChange({target: {name: 'photo', value: null}});

    files.map((file) => {
      const reader = new FileReader();
      reader.onabort = () => setError(errMsg)
      reader.onerror = () => setError(errMsg)
      reader.onload = () => {
        setError(null);
        props.onChange({target: {name: 'photo', value: reader.result}});
      }
      reader.readAsDataURL(file)
      return file;
    });
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    disabled: props.disabled,
    accept: {"image/png": [".png", ".jpeg", ".jpg"]},
    multiple: false,
    maxSize: 10 * 1024 * 1024,
    onDrop,
    onError: error => setError(error),
    onDropRejected: res => {
      if (res.length > 0) setError(res[0].errors[0]?.code?.split('-').join(' '))
    }
  });

  return (
    <>
      {
        !props.disabled
        ? "The photo you provided:"
        : <>Please upload a new photo that comply with the <a href="https://www.polyu.edu.hk/ar/docdrive/polyu-students/eng-forms/photograph_requirements.pdf" target="_blank">photo requirements</a>:</>
      }
      {
        !props.disabled && props.allowReupload
        ? <div>
          <b style={{fontSize: 13, color: "#981f31"}}>
            ( Pending Re-upload )
          </b>
        </div>
        : <br/>
      }
      <br/>
      <div {...getRootProps()}
        style={{
          textAlign: 'center',
          padding: 10,
          paddingTop: 80,
          paddingBottom: 80,
          borderWidth: '2px',
          borderColor: isDragActive ? "#981f31" : 'lightgray',
          borderStyle: 'dashed',
          minWidth: (dimension.width + 20),
          width: '100%',
          margin: 'auto',
          backgroundColor: '#fafafa',
          cursor: props.disabled ? 'default' : 'pointer',
        }}
      >
        {
          !props.photo
          ? <>
            <input {...getInputProps()} />
            <AddPhotoAlternateIcon color='primary' style={{fontSize: '50px'}}/>
          </>
          : <img src={props.photo} alt="Photo" height={dimension.height} width={dimension.width} />
        }
        {
          !props.disabled && <>
            <br />
            <br />
            <div style={{fontSize: 15}}>
              <b>
                Drag and drop here or <span style={{color: "#981f31"}}>browse</span>
              </b>
            </div>
            <div style={{color: 'grey', fontSize: 13}}>
              It must be a JPG or PNG, no larger than 10MB
            </div>
          </>
        }
        {
          !!error && <>
            <br />
            <br />
            <div style={{fontSize: 15, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
              <ErrorIcon color='primary' style={{marginRight: 10}} /><b>{error}</b>
            </div>
          </>
        }
      </div>
    </>
  );
}

export default PhotoUploadPanel;